import React from 'react';

const Tab = props => {
    const { children, disabled } = props;
    return <div>{disabled ? <div className="disabled-tab">You've not selected structure yet.</div> : children}</div>;
};

export default Tab;
